<template lang="pug">
v-layout.px-3(column)
    v-subheader.pl-4.mt-3.pb-3 Абонемент в бассейн
    v-layout(:class="{ 'px-4' : !$vuetify.breakpoint.xsOnly}")
      v-card(width="100%")
        v-card-text(v-if="!isUKRegion && !isRidderRegion")
          v-list.overflow-x-hidden
            v-list-tile.px-2(avatar ripple)
              v-list-tile-content
                | Данные для этого региона отсуствует
        v-card-text(v-if="isUKRegion")
          v-list.overflow-x-hidden
            v-list-tile.px-2(avatar ripple)
              v-list-tile-content
                | Казцинковцы, состоящие в Профсоюзе, могут посещать со скидкой тренажерный зал и бассейн в Физкультурно-оздоровительном комплексе г.Усть-Каменогорск по адресу: 
                b
                  | пр. Шакарима, 1/2.
                br
                | Для получения абонементов необходимо обращаться в профсоюзный комитет УК МК.
                br
                u
                  | Для приобретения абонементов необходимо представить администратору ФОК:
                | √ Удостоверение личности;
                br
                | √ Профсоюзный билет (получить в профкоме УКМК);
                br
                | √ Пропуск ТОО «Казцинк». 
                br
                br
                u
                  | Для посещения бассейна необходимо иметь:
                | ∆	Справку от терапевта (детям от педиатра)
                br
                | ∆	Шапочку для купания
                br
                | ∆	Купальный костюм (плавки)
                br
                | ∆	Предметы личной гигиены (мыло/гель для душа/шампунь, полотенце)
                br
                | ∆	Обувь на резиновой подошве (сланцы).
                br
                br
            v-list-tile.px-2(avatar ripple)
              v-list-tile-content
                table(style="width:70%")
                  tbody(style="width:100%")
                    tr
                      td(style="text-align:center; vertical-align: top;")
                        b
                          | ПРЕЙСКУРАНТ ЦЕН НА АБОНЕМЕНТ В ФОК
                    tr
                      td(style="text-align:center; vertical-align: top;")
                        b
                          | ДЛЯ ЧЛЕНОВ ПРОФСОЮЗА
                    tr
                      td(style="text-align:center; vertical-align: top;")
                        b
                          | 6 ПОСЕЩЕНИЙ В МЕСЯЦ

                table(style="border: 1px solid black; border-collapse: collapse; width:70%")
                  tbody(style="width:100%")
                    tr
                      td(style="border: 1px solid black; border-collapse: collapse; width:25%; text-align:center; vertical-align: top;")
                        b
                          | БАССЕЙН
                      td(style="border: 1px solid black; border-collapse: collapse; width:35%; text-align:center; vertical-align: top;")
                        u
                          | В ЛЕТНЕЕ ВРЕМЯ      
                        br
                        | с 06-45 ч. до 12-35 ч.
                        br
                        | с 13-35 ч. до 21-40 ч.
                        br
                        br
                        u
                          | В УЧЕБНОЕ ВРЕМЯ
                        br
                        | с 06-45 ч. до 07-50 ч.
                        br
                        | с 19-25 ч. до 21-40 ч.   
                        br
                        | &nbsp;          
                      td(style="border: 1px solid black; border-collapse: collapse; width:40%; text-align:center; vertical-align: top;")
                        b
                          u
                            | Стоимость абонемента 
                        br
                        | Общая - 9000 тг
                        br
                        | Оплачивает профсоюз - 4500 тг
                        br
                        | Оплачивает работник - 4950 тг
                    tr
                      td(style="border: 1px solid black; border-collapse: collapse; width:25%; text-align:center; vertical-align: top;")
                        b
                          | ТРЕНАЖЕРНЫЙ ЗАЛ
                      td(style="border: 1px solid black; border-collapse: collapse; width:35%; text-align:center; vertical-align: top;")
                        u
                          | В ЛЕТНЕЕ ВРЕМЯ      
                        br
                        | с 07-00 ч. до 13-00 ч.
                        br
                        | с 14-00 ч. до 21-00 ч.
                        br
                        br
                        u
                          | В УЧЕБНОЕ ВРЕМЯ
                        br
                        | с 07-00 ч. до 09-00 ч.
                        br
                        | с 19-00 ч. до 21-00 ч.
                        br
                        | &nbsp;
                      td(style="border: 1px solid black; border-collapse: collapse; width:40%; text-align:center; vertical-align: top;")
                        b
                          u
                            | Стоимость абонемента 
                        br
                        | Общая - 4000 тг
                        br
                        | Оплачивает профсоюз - 2000 тг
                        br
                        | Оплачивает работник - 2200 тг            
                    tr
                      td(style="border: 1px solid black; border-collapse: collapse; width:25%; text-align:center; vertical-align: top;")
                        b
                          | КОМПЛЕКС ТРЕНАЖЕРНЫЙ ЗАЛ + БАССЕЙН
                      td(style="border: 1px solid black; border-collapse: collapse; width:35%; text-align:center; vertical-align: top;")
                        u
                          | Тренажерный зал - В ЛЕТНЕЕ ВРЕМЯ
                        br
                        | с 07-00 ч. до 13-00 ч.
                        br
                        | с 14-00 ч. до 21-00 ч.
                        br
                        br
                        u
                          | В УЧЕБНОЕ ВРЕМЯ
                        br
                        | с 07-00 ч. до 09-00 ч.
                        br
                        | с 19-00 ч. до 21-00 ч.
                        br    
                        | &nbsp;       
                      td(style="border: 1px solid black; border-collapse: collapse; width:40%; text-align:center; vertical-align: top;")
                        b
                          u
                            | Стоимость абонемента 
                        br
                        | Общая - 12 000 тг
                        br
                        | Оплачивает профсоюз - 5000 тг
                        br
                        | Оплачивает работник - 7500 тг           
        v-card-text(v-if="isRidderRegion")
          v-list.overflow-x-hidden
              v-list-tile.px-2(avatar ripple)
                v-list-tile-content   
                  table(style="width:70%")
                    tbody(style="width:100%")
                      tr
                        td(style="text-align:center; vertical-align: top;")
                          b
                            | ИНФОРМАЦИЯ ПО АБОНЕМЕНТАМ В БАССЕЙН:
                  | Профсоюзные комитеты ППО ТОО «Казцинк» г.Риддер, ППО ПК «Казцинкмаш» г.Риддер и ППО РМП МК ТОО «Казцинк» г.Риддер предоставляют членам профсоюза индивидуальные абонементы на 10 посещений бассейна КДС ТОО «Казцинк», находящегося по адресу: г.Риддер, ул.Гоголя, д.55, со скидкой 50%. При оплате абонемента удерживается подоходный налог в размере 10%.
                  br
                  | Для получения абонементов необходимо обращаться в профсоюзные комитеты по месту работы.      
                  br
                  br             
                  table(style="width:70%")
                    tbody(style="width:100%")
                      tr
                        td(style="text-align:center; vertical-align: top;")
                          b
                            | Прайс на абонементы в бассейн КДС ТОО «Казцинк» для членов профсоюза на 2023-2024 гг.
                  br 
                  table(style="border: 1px solid black; border-collapse: collapse; width:70%")
                    tbody(style="width:100%")
                      tr
                        td(style="border: 1px solid black; border-collapse: collapse; width:25%; text-align:center; vertical-align: top;")
                          b
                            | Категория
                        td(style="border: 1px solid black; border-collapse: collapse; width:35%; text-align:center; vertical-align: top;")
                          b
                            | Общая стоимость/тенге                          
                        td(style="border: 1px solid black; border-collapse: collapse; width:40%; text-align:center; vertical-align: top;")
                          b
                            | Оплата члена профсоюза с ИПН, тенге
                      tr
                        td(style="border: 1px solid black; border-collapse: collapse; width:25%; text-align:center; ")
                          b
                            | Один абонемент
                            br
                            | (10 посещений)
                        td(style="border: 1px solid black; border-collapse: collapse; width:35%; text-align:center;")
                          | 15 000                        
                        td(style="border: 1px solid black; border-collapse: collapse; width:40%; text-align:center;")
                          | 8 250
</template>
  
<script>
export default {
  data() {
    return {
      iin: null,
      isUKRegion: false,
      isRidderRegion: false
    }
  },

  computed: {
    profile(){
      return this.$store.getters['auth/profile'];
    },
    employees(){
      return this.$store.getters['data/employees'];
    },
  },

  created() {
    this.iin = this.profile.userName;
    this.search(this.profile.userName);
  },

  methods: {
    search(iin){
      return this.$store.dispatch('data/getUser', iin)
    },
  },

  watch: {
    'employees'(employees) {
      if(this.employees.length > 0){
        if(this.employees[0].data){
          let data = this.employees[0].data;
          if(data.region){
            this.isUKRegion = (data.region.id === 'oskemen');
            this.isRidderRegion = (data.region.id === 'ridder') || (this.profile.userName === '830501301242');
            
          }
        }
      }
    }
  }
}
</script>

<style lang="stylus"></style>
  


// WEBPACK FOOTER //
// src/components/activity/Activity.vue